import { forwardRef, ReactNode } from 'react'
import { Box, BoxProps } from 'theme-ui'

export type PaperProps = BoxProps & {
  children: ReactNode | ReactNode[]
  variant?: 'fieldset' | 'alert' | 'default' | undefined
  withShadow?: boolean
}

const variantsMap = {
  default: 'cards.white',
  fieldset: 'cards.fieldset',
  alert: 'cards.yellow',
}

export const Paper = forwardRef<HTMLDivElement, PaperProps>(
  ({ variant, withShadow = false, children, ...rest }, ref) => (
    <Box
      ref={ref}
      variant={variantsMap[variant || 'default']}
      padding={6}
      style={{
        boxShadow: withShadow ? '0px -6px 20px rgba(0, 0, 0, 0.03)' : 'none',
      }}
      {...rest}>
      {children}
    </Box>
  )
)
